import './styles/product.css'
import { initReveal } from './reveal'
import { initNav } from './nav'
import { initAnalytics } from './analytics'
import { initBookingWidget } from './booking-widget'
import { initWebsiteChat } from './website-chat'
import { initVoicePlayers } from './voice-player'
import { initHub } from './hub'
import { initInbox } from './admin-inbox'
import { initBookings } from './admin-bookings'
import { initSocial } from './admin-social'
import { initEngagement } from './admin-engagement'
import { initPerformance } from './admin-performance'

document.documentElement.dataset['env'] = import.meta.env.VITE_ENV_NAME

initAnalytics()
initNav()
initReveal()
initBookingWidget()
initWebsiteChat()
initVoicePlayers()
initHub()

// The "Inside the app" sections render the operator app's real views as
// inert decoration — the same modules that power the demo page.
initInbox()
initBookings()
initSocial()
initEngagement()
initPerformance()
